<template>
  <div>
    <h6>Sommaire</h6>
    <table class="table table-sm table-bordered">
      <thead>
      <tr style="background-color: #f0f8ff">
        <OnRatiosTableHeaders1 />
      </tr>
      <tr style="background-color: #f0f8ff">
        <OnRatiosTableHeaders2 />
      </tr>
      </thead>
      <tbody>
      <tr>
        <OnRatiosTableCells :row="total" />
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import OnRatiosTableHeaders1 from "@/components/OnRatiosTableHeaders1";
import OnRatiosTableHeaders2 from "@/components/OnRatiosTableHeaders2";
import OnRatiosTableCells from "@/components/OnRatiosTableCells";

export default {
  name: 'OnRatiosEmploisTotal',
  components: {
    OnRatiosTableHeaders1,
    OnRatiosTableHeaders2,
    OnRatiosTableCells
  },
  props: {
    ratios: Array
  },
  computed: {
    total() {
      let sum_total_employed_ft = 0;
      let sum_total_employed_pt = 0;
      let sum_total_employed_ca = 0;
      let sum_rqrd_french_ft = 0;
      let sum_rqrd_french_pt = 0;
      let sum_rqrd_french_ca = 0;
      let sum_actual_french_ft = 0;
      let sum_actual_french_pt = 0;
      let sum_actual_french_ca = 0;
      let sum_total_emp = 0;
      let sum_rqrd_fr = 0;
      let sum_actual_fr = 0;
      let etp_diff = 0;
      for (let i = 0; i < this.ratios.length; i++) {
        sum_total_employed_ft += this.ratios[i].sum_total_employed_ft;
        sum_total_employed_pt += this.ratios[i].sum_total_employed_ft;
        sum_total_employed_ca += this.ratios[i].sum_total_employed_ft;
        sum_rqrd_french_ft += this.ratios[i].sum_rqrd_french_ft;
        sum_rqrd_french_pt += this.ratios[i].sum_rqrd_french_pt;
        sum_rqrd_french_ca += this.ratios[i].sum_rqrd_french_ca;
        sum_actual_french_ft += this.ratios[i].sum_actual_french_ft;
        sum_actual_french_pt += this.ratios[i].sum_actual_french_pt;
        sum_actual_french_ca += this.ratios[i].sum_actual_french_ca;
        sum_total_emp += this.ratios[i].sum_total_emp;
        sum_rqrd_fr += this.ratios[i].sum_rqrd_fr;
        sum_actual_fr += this.ratios[i].sum_actual_fr;
        etp_diff += this.ratios[i].etp_diff;
      }

      let etp_rqrd_ratio = 0;
      if (sum_total_emp > 0) {
        etp_rqrd_ratio = (sum_rqrd_fr / sum_total_emp).toFixed(2);
      }

      let etp_actual_ratio = 0;
      if (sum_total_emp > 0) {
        etp_actual_ratio = (sum_actual_fr / sum_total_emp).toFixed(2);
      }

      let etp_diff_pc = null;
      if (sum_rqrd_fr !== 0) {
        etp_diff_pc = (100 + ((sum_actual_fr - sum_rqrd_fr) / sum_rqrd_fr) * 100).toFixed(2);
      }

      return {
        sum_total_employed_ft: sum_total_employed_ft,
        sum_total_employed_pt: sum_total_employed_pt,
        sum_total_employed_ca: sum_total_employed_ca,
        sum_rqrd_french_ft: sum_rqrd_french_ft,
        sum_rqrd_french_pt: sum_rqrd_french_pt,
        sum_rqrd_french_ca: sum_rqrd_french_ca,
        sum_actual_french_ft: sum_actual_french_ft,
        sum_actual_french_pt: sum_actual_french_pt,
        sum_actual_french_ca: sum_actual_french_ca,
        sum_total_emp: sum_total_emp.toFixed(2),
        sum_rqrd_fr: sum_rqrd_fr.toFixed(2),
        sum_actual_fr: sum_actual_fr.toFixed(2),
        etp_rqrd_ratio : etp_rqrd_ratio,
        etp_actual_ratio : etp_actual_ratio,
        etp_diff: etp_diff,
        etp_diff_pc: etp_diff_pc
      };
    }
  }
}

</script>